import { Alert, List, ListItem, ListItemText, Box, Avatar, Typography, Divider, Paper, Container, Button, TablePagination, Stack, TextField, IconButton, ToggleButton, ToggleButtonGroup, Snackbar } from "@mui/material";
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemIcon from '@mui/material/ListItemIcon';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid2';
import LoadingButton from '@mui/lab/LoadingButton';
import React, { useContext, useEffect, useState } from "react";
import { AuthContext, FireactContext, SetPageTitle } from "../../lib/core";
import { useNavigate } from "react-router-dom";
import { httpsCallable } from "firebase/functions";
import { collection, query, where, and, or, getDocs, getDoc, doc, setDoc, addDoc, deleteDoc, GeoPoint, orderBy } from 'firebase/firestore';
import { getAuth, sendEmailVerification } from "firebase/auth";
import CircularProgress from '@mui/material/CircularProgress';
import FolderIcon from '@mui/icons-material/Folder';
import DeleteIcon from '@mui/icons-material/Delete';

import {AdminPageContext} from "./AdminPageContext";

export const AdminWebsiteUsers = () => {
    const auth = getAuth();
    const { authInstance, firestoreInstance, functionsInstance } = useContext(AuthContext);
    const { config } = useContext(FireactContext);
    const navigate = useNavigate();
    const [loaded, setLoaded] = useState(false);
    const [error, setError] = useState(null);
    const [ prompt, setPrompt ] = useState(null);
    const [processing, setProcessing] = useState(false);
    const { authUser } = useContext(AuthContext);
    const [usersList, setUsersList] = useState(null);

    const { admin } = useContext(AdminPageContext);

    //console.log('authUser ', authUser);
    console.log('admin', admin);

    useEffect(() => {
        if (admin == 'super') {
            const getAdminListUsers = httpsCallable(functionsInstance, 'fireactjsSaas-adminlistusers');
            getAdminListUsers().then((res) => {
                console.log('res', res);
                if (res.data) {
                    setUsersList(res.data.users);
                }
                setLoaded(true);
            });
        } else {
            setLoaded(true);
        }
    }, [auth.currentUser.uid, admin, functionsInstance, firestoreInstance]);
    
    return (<>
        {loaded ? (
            <>
            <Box sx={{ flexGrow: 1 }}>
                <Grid container spacing={0} 
                    sx={{
                        '--Grid-borderWidth': '1px',
                        borderTop: 'var(--Grid-borderWidth) solid',
                        borderLeft: 'var(--Grid-borderWidth) solid',
                        borderColor: 'divider',
                        '& > div': {
                        borderRight: 'var(--Grid-borderWidth) solid',
                        borderBottom: 'var(--Grid-borderWidth) solid',
                        borderColor: 'divider',
                        },
                    }}
                >
                    <Grid size={{ xs: 12, md: 12 }}>
                        {error !== null &&
                            <Alert severity="error">{error}</Alert>
                        }
                        {prompt !== null &&
                            <Alert severity="info">
                                {prompt}
                            </Alert>
                        }
                    </Grid>
                    <Grid size={{ xs: 12, md: 8 }}>
                        <Box sx={{ flexGrow: 1, p: 0, width: '100%', backgroundColor: '#FFF'}} >
                            {admin == 'super' && (
                                    <>
                                    <Grid container spacing={0}>
                                        <Grid xs={12} md={12}>
                                            <Box sx={{p:2}}>
                                            ITDQ Website Users
                                            </Box>
                                        </Grid>
                                    </Grid>
                                    </>
                            )}
                            {admin == 'manager' && (
                                <Box sx={{height: '70vh', p: 10, alignContent: 'center', textAlign: 'center'}}>
                                    Business Co-operator Access Permission
                                </Box>
                            )}
                            {admin == '' && (
                                <>
                                    Access Permission is required.
                                </>
                            )}
                        </Box>
                    </Grid>
                    <Grid size={{ xs: 12, md: 4 }} display="flex" justifyContent="left" alignItems="center">
                        <Typography>
                        Access Level - {admin}    
                        </Typography>
                    </Grid>
                </Grid>
            </Box>
            {admin == 'super' && (
                <>
                <Box sx={{ flexGrow: 1 }}>
                    <Grid container spacing={0} >
                        <Grid size={{ xs: 12, md: 12 }}>
                            <Box sx={{ flexGrow: 1, p: 0, width: '100%', backgroundColor: '#FFF'}} >
                                <Typography  variant="h6" gutterBottom>Users</Typography>
                                <Typography gutterBottom>
                                    
                                </Typography>
                            </Box>
                            <Box sx={{ flexGrow: 1, p: 0, width: '100%', backgroundColor: '#FFF'}} >
                            {usersList && (<>
                                <List dense={true}>
                                    {usersList.map(user => (<>
                                        <ListItem
                                        secondaryAction={
                                            <IconButton edge="end" aria-label="delete">
                                            <DeleteIcon />
                                            </IconButton>
                                        }
                                        >
                                        <ListItemAvatar>
                                            <Avatar alt={user.displayName} src={user.photoURL} />
                                        </ListItemAvatar>
                                        <ListItemText
                                            primary={user.displayName}
                                            secondary={user.profile_uid}
                                        />
                                        </ListItem>
                                    </>))}
                                </List>
                            </>)}
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
                </>
            )}
            </>
        ) : (<>
            <Box sx={{width: '100%', p: 5, textAlign:'center'}}><CircularProgress /></Box>
        </>)}
    </>
    )
}
